import React from 'react';
import PropTypes from 'prop-types';
import { applyContainerQuery } from 'react-container-query';

import AnnouncementBar from './AnnouncementBar';
import AnnouncementModal from './AnnouncementModal';
import announcementTypes from './announcementTypes';
import containerQuery from '../../constants/containerQuery';

import './Announcement.scss';

const { HEADER, POPUP, FOOTER } = announcementTypes;

const Announcement = (props) => {
  const { type, colors } = props;
  let Component;

  switch (type) {
    case HEADER:
      Component = (
        <AnnouncementBar
          {...props}
          colors={colors[HEADER]}
        />
      );
      break;
    case POPUP:
      Component = (
        <AnnouncementModal
          {...props}
          colors={colors[POPUP]}
        />
      );
      break;
    case FOOTER:
      Component = (
        <AnnouncementModal
          {...props}
          bodyOpenClassName={null}
          colors={colors[POPUP]}
        />
      );
      break;
    default:
      Component = null;
  }

  return (<div style={{ width: '100%' }}>{Component}</div>);
};

Announcement.propTypes = {
  $rootScope: PropTypes.shape({}).isRequired,
  type: PropTypes.oneOf([HEADER, POPUP, FOOTER]),
  colors: PropTypes.shape({
    [HEADER]: PropTypes.shape({
      background: PropTypes.string,
      font: PropTypes.string,
    }),
  }),
};

Announcement.defaultProps = {
  type: HEADER,
  colors: {
    [HEADER]: {},
    [POPUP]: {},
  },
};

Announcement.displayName = 'Announcement';
export { Announcement as Component };
export default applyContainerQuery(Announcement, containerQuery);
